import { httpClient } from '../utils/httpClient';
import {
  AsistenciaMasivoPayload,
  AsistenciaUpdatePayload,
  AsistenciaResponse,
} from '../types/asistencia.types';

// ============================================================
// asistenciaService.ts
// ============================================================

export const asistenciaService = {

  // POST /asistencias/masivo — registro masivo (primera vez del día)
  async registrarMasivo(payload: AsistenciaMasivoPayload): Promise<AsistenciaResponse[]> {
    const data = await httpClient.post<AsistenciaResponse[]>('/asistencias/masivo', payload);
    return Array.isArray(data) ? data : [];
  },

  // PUT /asistencias/{id} — actualizar asistencia individual
  async actualizar(id: number, payload: AsistenciaUpdatePayload): Promise<AsistenciaResponse> {
    return httpClient.put<AsistenciaResponse>(`/asistencias/${id}`, payload);
  },

  // GET /asistencias/asignacion/{id}/fecha/{fecha} — vista docente por fecha
  async listarPorAsignacionYFecha(
    asignacionAcademicaId: number,
    fecha: string,
  ): Promise<AsistenciaResponse[]> {
    const data = await httpClient.get<AsistenciaResponse[]>(
      `/asistencias/asignacion/${asignacionAcademicaId}/fecha/${fecha}`
    );
    return Array.isArray(data) ? data : [];
  },

  // GET /asistencias/matricula/{id}/asignacion/{id} — historial en un curso
  async listarPorMatriculaYAsignacion(
    matriculaId: number,
    asignacionAcademicaId: number,
  ): Promise<AsistenciaResponse[]> {
    const data = await httpClient.get<AsistenciaResponse[]>(
      `/asistencias/matricula/${matriculaId}/asignacion/${asignacionAcademicaId}`
    );
    return Array.isArray(data) ? data : [];
  },

  // GET /asistencias/matricula/{id} — historial completo del estudiante
  async listarPorMatricula(matriculaId: number): Promise<AsistenciaResponse[]> {
    const data = await httpClient.get<AsistenciaResponse[]>(
      `/asistencias/matricula/${matriculaId}`
    );
    return Array.isArray(data) ? data : [];
  },

  // GET /asistencias/estudiante/{id}/anio/{anioId}/asignacion/{asignacionId}
  async listarPorEstudianteAnioAsignacion(
    estudianteId: number,
    anioEscolarId: number,
    asignacionId: number,
  ): Promise<AsistenciaResponse[]> {
    const data = await httpClient.get<AsistenciaResponse[]>(
      `/asistencias/estudiante/${estudianteId}/anio/${anioEscolarId}/asignacion/${asignacionId}`
    );
    return Array.isArray(data) ? data : [];
  },
};
